import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { getRem, BREAKPOINTS, transitionAnimation } from "../../core";
import { animated } from 'react-spring/web.cjs';
import styled from 'styled-components';
var StyledMenuContainer = styled(animated.div).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['placement', 'triggerOffset', 'targetRef', 'isOpen'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  box-sizing: border-box;\n  margin-top: ", ";\n  margin: 0;\n  max-height: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  overflow-y: auto;\n  position: fixed;\n  width: auto;\n  z-index: ", ";\n\n  @media ", " {\n    max-height: ", ";\n  }\n"])), transitionAnimation('opacity'), function (_ref) {
  var theme = _ref.theme;
  return theme.color.additional.light.value;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.size.borderRadius.large.value;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.elevation[4].value;
}, getRem('1px'), getRem('288px'), getRem('280px'), getRem('128px'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.zIndex.dropdownMenu.value;
}, BREAKPOINTS.L, getRem('208px'));
export { StyledMenuContainer };